import trackingDefaultDataTypesHydrator from './trackingDefaultDataTypes';
import trackingTourCriteriaHydrator from './trackingTourCriteria';

export default async (options) => {
    const trackingStartSearchData = {};
    const { searchUuid, source } = options;
    const { productType } = options.searchOptions;
    const trackingDefaultDataTypes = await trackingDefaultDataTypesHydrator(options.searchOptions);
    const trackingTourCriteria = trackingTourCriteriaHydrator(options.searchOptions);

    _.extend(trackingStartSearchData, {
        source,
        searchUuid,
        productType,
    }, trackingDefaultDataTypes, trackingTourCriteria);

    return trackingStartSearchData;
};